export default {
    infectious_syndrome_1: 'All infectious syndromes',
    infectious_syndrome_2: 'Infections of the skin and subcutaneous systems',
    infectious_syndrome_3: 'Bloodstream infections',
    infectious_syndrome_4: 'Diarrhea',
    infectious_syndrome_5: 'Endocarditis',
    infectious_syndrome_6: 'Infections of bones, joints, and related organs',
    infectious_syndrome_7: 'Lower respiratory infections',
    infectious_syndrome_8: 'Meningitis',
    infectious_syndrome_9: 'Peritoneal and intra-abdominal infections',
    infectious_syndrome_10: 'Tuberculosis',
    infectious_syndrome_11:
        'Typhoid fever, paratyphoid fever, and invasive non-typhoidal Salmonella',
    infectious_syndrome_12: 'Urinary tract infections and pyelonephritis',
    infectious_syndrome_14: 'Encephalitis',
    infectious_syndrome_15: 'Eye infections',
    infectious_syndrome_16: 'Carditis, myocarditis, and pericarditis',
    infectious_syndrome_17: 'Other parasitic infections',
    infectious_syndrome_18: 'Upper respiratory infections',
    infectious_syndrome_19:
        'Myelitis, meningoencephalitis, and other central nervous system infections',
    infectious_syndrome_20: 'Genital infection',
    infectious_syndrome_21: 'Hepatitis',
    infectious_syndrome_22: 'Oral infections',
    infectious_syndrome_23: 'Other unspecified site infections',
    infectious_syndrome_25: 'Sexually transmitted infections',

    infectious_syndrome_10000: 'Cardiac infections',
    infectious_syndrome_10001: 'Meningitis and other central nervous system infections',
    infectious_syndrome_10002: 'Respiratory infections',
    infectious_syndrome_10003: 'Chlamydia and gonorrhea',
    infectious_syndrome_10004: 'Malaria',
};
